import { AffectedOperation, UnaffectedOperation } from './OperationsCheckList';

export const searchOperations = (
  operations: (AffectedOperation | UnaffectedOperation)[],
  searchTerm: string,
): (AffectedOperation | UnaffectedOperation)[] => {
  if (!searchTerm) {
    return operations;
  }

  return operations.filter(
    (operation) =>
      operation.name &&
      (operation.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        operation.id.toLowerCase().includes(searchTerm.toLowerCase())),
  );
};
